import './event-details.html.twig';
import './event-details.scss';